// import React, { useEffect } from "react";
// import { Eye, Target } from "lucide-react";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const Company = () => {
//   useEffect(() => {
//     AOS.init({ duration: 800 });
//   }, []);

//   return (
//     <div className="bg-white text-gray-800 overflow-hidden">
//       {/* Hero Section */}
//       <div className="bg-gradient-to-r from-green-600 via-teal-600 to-indigo-700 py-24 text-center text-white">
//         <h1 className="text-4xl lg:text-5xl font-bold mb-4">
//           About Sanctus Property Pvt Ltd
//         </h1>
//         <p className="text-lg lg:text-xl max-w-2xl mx-auto">
//           With over 15 years of experience in construction and real estate,
//           we've built our reputation on quality, reliability, and customer
//           satisfaction.
//         </p>
//       </div>

//       {/* Vision & Mission */}
//       <div className="px-6 lg:px-24 py-16 space-y-20">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div data-aos="fade-right">
//             <div className="flex items-center mb-4">
//               <Eye className="h-10 w-10 text-green-500 mr-3" />
//               <h2 className="text-3xl font-bold text-blue-700">Our Vision</h2>
//             </div>
//             <p className="text-lg text-gray-600">
//               Be the leading construction brand, recognized for quality and
//               innovation, building enduring value for clients and communities.
//             </p>
//           </div>
//           <div data-aos="fade-left">
//             <div className="flex items-center mb-4">
//               <Target className="h-10 w-10 text-green-500 mr-3" />
//               <h2 className="text-3xl font-bold text-blue-700">Our Mission</h2>
//             </div>
//             <p className="text-lg text-gray-600">
//               Deliver high-quality buildings on time and on budget, exceeding
//               expectations through an innovative approach, skilled team, and
//               strong client relationships.
//             </p>
//           </div>
//         </div>

//         {/* Supporting Values */}
//         <div>
//           <h2
//             className="text-3xl font-bold text-blue-700 mb-10 text-center"
//             data-aos="fade-up"
//           >
//             Supporting Values
//           </h2>

//           <ul className="space-y-6 max-w-4xl mx-auto text-gray-700 text-lg">
//             {[
//               "Quality: Delivering projects of the highest standard through continuous improvement and attention to detail.",
//               "Safety: Prioritizing the health and safety of all employees and stakeholders at every stage of a project.",
//               "Integrity: Upholding honesty, transparency, and ethical conduct in all dealings.",
//               "Teamwork: Fostering a collaborative environment built on mutual respect and support.",
//               "Innovation: Embracing new ideas and technologies to drive efficiency and deliver cutting-edge solutions.",
//               "Sustainability: Minimizing environmental impact through eco-friendly practices and materials, and contributing to sustainable development.",
//             ].map((item, idx) => (
//               <li key={idx} className="flex items-start" data-aos="fade-up">
//                 <div className="w-2 h-2 bg-blue-600 rounded-full mt-[6px] mr-3 flex-shrink-0" />
//                 <span>{item}</span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Company;

import React, { useEffect } from "react";
import { Eye, Target } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";

const Company = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <div className="bg-white text-gray-800 overflow-hidden">
      {/* Hero Section */}
      {/* <div className="bg-gradient-to-r from-green-600 via-teal-600 to-indigo-700 py-24 text-center text-white">
        <h1 className="text-4xl lg:text-5xl font-bold mb-4">
          About Sanctus Property Pvt Ltd
        </h1>
        <p className="text-lg lg:text-xl max-w-2xl mx-auto">
          With over 15 years of experience in construction and real estate,
          we've built our reputation on quality, reliability, and customer
          satisfaction.
        </p>
      </div> */}
      {/* <section
        className="relative flex items-center justify-center h-[50vh] container "
        style={{
          
          backgroundImage: "url('/Sanctus Logo.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        
      </section> */}

      <div className="p-5">
        <img src="/Sanctus Logo.png" className="p-5"></img>
      </div>

      {/* <div className="p-5">
        <video
          className="p-5"
          src="/company.mp4"
          autoPlay
          muted
          loop
          style={{ width: "100%", maxHeight: "500px", objectFit: "cover" }}
        />
      </div> */}

      {/* Vision & Mission Cards */}
      <div className="px-6 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Vision Card */}
          <div
            className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-2xl transition-all duration-300"
            data-aos="fade-up"
          >
            <div className="flex items-center mb-4">
              <Eye className="h-10 w-10 text-green-500 mr-3" />
              <h2 className="text-2xl font-bold text-blue-700">Our Vision</h2>
            </div>
            <p className="text-gray-600 text-lg">
              Be the leading construction brand, recognized for quality and
              innovation, building enduring value for clients and communities.
            </p>
          </div>

          {/* Mission Card */}
          <div
            className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-2xl transition-all duration-300"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="flex items-center mb-4">
              <Target className="h-10 w-10 text-green-500 mr-3" />
              <h2 className="text-2xl font-bold text-blue-700">Our Mission</h2>
            </div>
            <p className="text-gray-600 text-lg">
              Deliver high-quality buildings on time and on budget, exceeding
              expectations through an innovative approach, skilled team, and
              strong client relationships.
            </p>
          </div>
        </div>
      </div>

      {/* Supporting Values Section */}

      <div className="bg-gray-50 py-20 px-6 lg:px-24">
        <div className="inline-block">
          <h3 className="text-3xl text-center font-bold text-blue-700 mb-2">
            Supporting Values
          </h3>
          <div className="h-1 w-40 bg-[#6FEF34] mx-auto mb-6 blink-underline"></div>
        </div>

        <ul className="inline-block space-y-6 max-w-4xl mx-auto text-gray-700 text-lg">
          {[
            "Quality: Delivering projects of the highest standard through continuous improvement and attention to detail.",
            "Safety: Prioritizing the health and safety of all employees and stakeholders at every stage of a project.",
            "Integrity: Upholding honesty, transparency, and ethical conduct in all dealings.",
            "Teamwork: Fostering a collaborative environment built on mutual respect and support.",
            "Innovation: Embracing new ideas and technologies to drive efficiency and deliver cutting-edge solutions.",
            "Sustainability: Minimizing environmental impact through eco-friendly practices and materials, and contributing to sustainable development.",
          ].map((item, idx) => (
            <li
              key={idx}
              className="flex items-start"
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <div className="p-5">
          <video
            className="p-5"
            src="/company.mp4"
            autoPlay
            muted
            loop
            style={{ width: "100%", maxHeight: "500px", objectFit: "cover" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Company;
